import { useMemo } from "react";
import {
  PLATFORM_MODULES,
  PLATFORM_MODULES_OPTIONS,
} from "@miplatform/constants";
import { IFeatureFlagsResponse } from "@miplatform/types";
import { useFeatureFlagsContext } from "../FeatureFlagProvider/FeatureFlagProvider";

export const PLATFORM_MODULE_TO_FLAG_KEY: Partial<
  Record<string, keyof IFeatureFlagsResponse>
> = {
  [PLATFORM_MODULES.MI_DISPATCH]: "miDispatchEnabled",
  [PLATFORM_MODULES.MI_SCHEDULING]: "miSchedulingEnabled",
  [PLATFORM_MODULES.MI_ACCOUNTING]: "miAccountingEnabled",
  [PLATFORM_MODULES.MI_INSPECTIONS]: "miInspectionsEnabled",
  [PLATFORM_MODULES.MI_ESTIMATING]: "miEstimatingEnabled",
  [PLATFORM_MODULES.MI_DAY]: "miDayEnabled",
};

export const useFeatureFlags = () => {
  const { featureFlags: contextFeatureFlags } = useFeatureFlagsContext();

  const hasAllFeatureFlagsEnabled = (
    keys: (keyof IFeatureFlagsResponse)[]
  ): boolean => {
    if (
      contextFeatureFlags &&
      keys.length > 0 &&
      keys.every((key) => contextFeatureFlags[key])
    ) {
      return true;
    }

    return false;
  };

  const platformModulesWithFeatureFlags = useMemo(() => {
    return PLATFORM_MODULES_OPTIONS.filter((module) => {
      const featureFlagKey = PLATFORM_MODULE_TO_FLAG_KEY[module.value];
      if (!contextFeatureFlags || !featureFlagKey) {
        return false;
      }

      return contextFeatureFlags[featureFlagKey];
    });
  }, [contextFeatureFlags]);

  return {
    featureFlags: contextFeatureFlags,
    hasAllFeatureFlagsEnabled,
    platformModulesWithFeatureFlags,
  };
};
